(() => {
  'use strict';
  if (customElements.get('bam-bfcm-offer')) return;
  class BfcmOffer extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.life = new AbortController();
      this.config = JSON.parse(this.querySelector('[data-bfcm-config]').textContent);
      this.root = this.closest('[data-section-type="product-section"]');
      if (!this.root) return;
      this.button = this.root.querySelector('.product__add-button');
      this.sticky = this.root.querySelector('[data-bfcm-sticky]');
      this.money = new Intl.NumberFormat(this.config.locale || 'en-US', {style: 'currency', currency: this.config.currency || 'USD'});
      this.update = this.update.bind(this);
      this.root.addEventListener('change', () => {
        this.update();
        requestAnimationFrame(this.update);
      }, {signal: this.life.signal});
      this.observer = new MutationObserver(this.update);
      this.root.querySelectorAll('.formVariantId, .product__add-button').forEach(el => this.observer.observe(el, {attributes:true, attributeFilter:['value','disabled']}));
      this.root.querySelectorAll('[data-bfcm-builder]').forEach(link => link.addEventListener('click', () => {
        this.update();
        const url = new URL(link.href, location.origin);
        if (this.variant) url.searchParams.set('bam_variant', this.variant.id);
        url.searchParams.set('bam_product', link.dataset.productHandle);
        const preview = new URLSearchParams(location.search).get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        link.href = url.href;
      }, {signal:this.life.signal}));
      if (this.sticky && this.button) {
        this.stickyButton = this.sticky.querySelector('[data-bfcm-submit]');
        this.stickyButton.addEventListener('click', () => {
          this.update();
          if (!this.button.disabled) this.button.click();
        }, {signal:this.life.signal});
        this.updateSticky = () => {
          if (this.scrollFrame) return;
          this.scrollFrame = requestAnimationFrame(() => {
            this.scrollFrame = null;
            this.sticky.hidden = this.button.getBoundingClientRect().bottom >= 0;
          });
        };
        this.intersection = new IntersectionObserver(this.updateSticky);
        this.intersection.observe(this.button);
        window.addEventListener('scroll', this.updateSticky, {passive:true,signal:this.life.signal});
        window.addEventListener('resize', this.updateSticky, {passive:true,signal:this.life.signal});
        this.updateSticky();
      }
      this.update();
    }
    update() {
      const picker = this.root.querySelector('.product__variants-swatches, .product__variants-select.no-js-hidden');
      const optionNodes = picker ? [...picker.querySelectorAll('input[type="radio"]:checked, select.js-variant-selector')] : [];
      const options = optionNodes.map(el => el.value);
      const id = this.root.querySelector('.formVariantId')?.value || this.config.selected;
      const variant = options.length ? this.config.variants.find(v => v.options.length === options.length && v.options.every((opt,i) => opt === options[i])) : this.config.variants.find(v => String(v.id) === String(id));
      this.variant = variant;
      this.querySelectorAll('[data-bfcm-tier-price]').forEach(element => {
        element.textContent = variant
          ? this.money.format(Math.min(variant.price, Math.max(variant.price, Number(variant.compare_at_price) || 0) - Math.floor(Math.max(variant.price, Number(variant.compare_at_price) || 0) * Number(element.dataset.rate) / 100)) / 100)
          : '—';
      });
      if (this.stickyButton) {
        this.stickyButton.disabled = this.button.disabled || !variant?.available;
        this.stickyButton.textContent = this.button.value || this.button.textContent;
      }
    }
    disconnectedCallback() {
      this.life?.abort(); cancelAnimationFrame(this.scrollFrame); this.observer?.disconnect(); this.intersection?.disconnect(); this.ready = false;
    }
  }
  customElements.define('bam-bfcm-offer', BfcmOffer);
})();
